// eslint-disable-next-line
export enum QueryKeys {
  BENEFITS = "benefits",
}
